import { Controller } from 'stimulus'
import CheckoutController from './checkout_controller'
import { AddressData } from '../lib/types'

export default class FormSmsOptInController extends Controller {
  static targets = ['checkbox']
  declare checkboxTarget: HTMLInputElement

  declare checkoutOutlet: CheckoutController
  static outlets = ['checkout']

  connect() {
    this.setInitialValues()
  }

  setInitialValues() {
    const sms_opt_in = this.checkoutOutlet.signupData.address?.sms_opt_in
    this.checkboxTarget.checked = sms_opt_in || false
  }

  toggleCheckbox(event: Event) {
    const checkbox = event.target as HTMLInputElement

    if (!this.checkoutOutlet.signupData.address) {
      this.checkoutOutlet.signupData.address = {} as AddressData
    }

    this.checkoutOutlet.signupData.address = {
      ...this.checkoutOutlet.signupData.address,
      sms_opt_in: checkbox.checked,
    }
  }
}
